module.exports = __webpack_public_path__ + "img/shoplogo.d3eaa76d.svg";